<template lang="pug">
.show-card-actions
  grid-actions(
    v-for="(handler, i) in headerHandlers",
    :key="handler.name",
    ref="grid-actions",
    @refresh-table="refreshTable",
    @open-form="openForm",
    :parentData="gridActionsParentData(i + 1, handler)"
  )
  grid-actions(
    v-if="shouldShowLegacyCrud",
    ref="crud-actions",
    @refresh-table="refreshTable",
    @open-form="openForm",
    :parentData="legacyCrudActionsParentData"
  )

  .button-wrapper(v-for="(button, i) in buttons", :key="button.name", :style="button.style.wrapper")
    q-btn.show-card-action(flat, no-caps, @click="onClickButton(button)", :style="button.style.button")
      template(v-if="button.icon && button.icon.length > 0", slot="default")
        inline-svg(
          :class="[button.name + '-icon']",
          :style="button.style.icon",
          :src="require(`../../../assets/icons/show/actions/${button.icon}`)"
        )
      template(v-if="button.label && button.label.length > 0", slot="default")
        span.action-label {{ button.label }}
      inline-svg.arrow-down-actions-icon(
        :src="require(`../../../assets/icons/dropdown.svg`)",
        v-if="button.options?.length > 0"
      )
    .button-options(v-if="showButtonOptions(buttons, button.name)")
      .button-options-item(
        v-for="option in button.options",
        :key="option.name",
        @click="onClickOption(option, button)"
      ) {{ option.label }}

  page-dialogs(ref="dialogsRef", name="acts", :rowId="actId")
</template>

<script>
import gridActions from "../grid/gridActions";
import { handleError } from "@/services/handleErrors";
import pageDialogs from "../ui/dialogs/pageDialogs.vue";
import { Notify } from "quasar";
import i18n from "@/plugins/vue-i18n";

export default {
  components: {
    gridActions,
    pageDialogs,
  },

  props: {
    parentData: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      path: this.parentData.path,
      transition_key: this.parentData.transition_key,
      grid: this.parentData.grid,
      grid_key: this.parentData.grid_key,
      additional_transition_params: this.parentData.additional_transition_params || {},
      buttons: this.parentData.data?.buttons,
      actId: null,
      dialogsRef: null,
    };
  },

  computed: {
    row() {
      return this.parentData?.row;
    },
    handlers() {
      return this.parentData.data?.handlers || [];
    },
    activities() {
      return this.parentData.data?.activities || [];
    },
    backendCrud() {
      return this.parentData.data?.crud || [];
    },
    storedCrud() {
      return this.getStoredActions("crud").crud || [];
    },
    crud() {
      return this.backendCrud.length > 0 ? this.backendCrud : this.storedCrud;
    },
    useBackendCrudActions() {
      return this.parentData.useBackendCrudActions || false;
    },
    headerHandlers() {
      if (!this.useBackendCrudActions) {
        return this.handlers;
      }

      return this.handlers.filter(handler => handler.name !== "crud" || this.crud.length > 0);
    },
    hasCrudHandler() {
      return this.handlers.some(handler => handler.name === "crud");
    },
    shouldShowLegacyCrud() {
      return this.useBackendCrudActions && this.crud.length > 0 && !this.hasCrudHandler;
    },
    legacyCrudActionsParentData() {
      return {
        index: (this.handlers || []).length + 1,
        actions: { crud: this.crud },
        row: this.row,
        grid: this.grid,
        grid_key: this.grid_key,
        path: this.path,
        transition_key: this.transition_key,
        default_class: "grid-actions",
        actions_icon_path: "grid/actions.svg",
      };
    },
  },

  mounted() {
    document.body.addEventListener("click", this.hideAllOptions);
  },

  beforeDestroy() {
    document.body.removeEventListener("click", this.hideAllOptions);
  },

  methods: {
    hideAllOptions() {
      const buttonOptionsEl = event.target.closest(".button-options");
      const buttonEl = event.target.closest(".show-card-action");

      if (buttonOptionsEl || buttonEl) {
        return;
      } else {
        this.buttons = this.buttons.map(button => {
          if (button.options?.length > 0) {
            button.show = false;
          }
          return button;
        });
      }
    },

    showButtonOptions(buttons, name) {
      const button = buttons.find(item => item.name === name);
      return button.options?.length > 0 && button.show === true;
    },

    gridActionsParentData(index, handler) {
      const params = {
        index,
        actions: this.getHandleActions(handler.name),
        row: this.row,
        grid: this.grid,
        grid_key: this.grid_key,
        path: this.path,
        transition_key: this.transition_key,
        btn_label: handler.label,
        default_class: `grid-actions ${handler.name}`,
        actions_icon_path: handler.icon ? `show/actions/${handler.icon}` : "grid/actions.svg",
      };

      // "handle" name occurs only elements of transiosion
      if (handler.name === "handle") {
        params["additional_transition_params"] = this.additional_transition_params;
        params["additional_activities_params"] = this.getHandleActions("activities");

        if (this.activities?.length && !Object.keys(params["additional_activities_params"])?.length) {
          params["additional_activities_params"] = { activities: this.activities };
        }
      }

      return params;
    },

    openActView(id) {
      this.actId = id;

      this.$nextTick(() => {
        this.$refs.dialogsRef?.openShow?.();
      });
    },

    async onClickOption(option, button) {
      const onclick = option.onсlick;
      let responseData = null;

      if (option.method) {
        try {
          if (option.method === "post") {
            const { data } = await this.$backend.create(`/api/v3/${option.path}`);
            responseData = data;

            if (data?.message) Notify.create(data?.message);
          }
          if (option.method === "get") {
            const { data } = await this.$backend.index(`/api/v3/${option.path}`, {});
            responseData = data;

            if (data?.message) Notify.create(data?.message);
          }
          if (option.method === "patch") {
            const { data } = await this.$backend.patch(`/api/v3/${option.path}`, {});
            responseData = data;

            if (data?.message) Notify.create(data?.message);
          }
        } catch (err) {
          await handleError(err);
          return;
        }

        this.refreshTable({
          attr: this.row,
          action: option.name,
          source: { buttonName: button.name },
        });
        this.showActCreatedNotification(button, option, responseData);
      }

      if (onclick) {
        // Тоже убрать и вставлять просто id
        const match = option.path?.match(/(\d+)$/);
        const id = match ? Number(match[1]) : null;

        if (id) {
          this[onclick](id);
        } else {
          this[onclick]();
        }
      }
    },

    showActCreatedNotification(button, option, responseData) {
      if (button.name !== "act" || option.name !== "create") {
        return;
      }

      const actId = Number(responseData?.data?.id || responseData?.id);

      if (!Number.isInteger(actId) || actId <= 0) {
        return;
      }

      const locales = i18n.messages[this.current_locale] || i18n.messages[i18n.locale] || i18n.messages.ru;
      const message = (locales.actCreated || i18n.messages.ru.actCreated).replace("{id}", actId);

      this.$q.notify({
        message,
        timeout: 20000,
        actions: [
          {
            label: locales.openAct || i18n.messages.ru.openAct,
            style: "color: #5b7aff",
            handler: () => {
              this.$router.push({ name: "acts", query: { id: actId, show: "true" } });
            },
          },
        ],
      });
    },

    onClickButton(button) {
      if (button.options?.length > 0) {
        this.buttons = this.buttons.map(item => {
          if (item.options?.length > 0) {
            if (button.show === true || button.show === false) {
              button.show = !button.show;
            } else {
              button.show = true;
            }
          }
          return item;
        });
        return;
      }

      const onclick = button.onclick;

      this.$emit("click", button.name);

      if (onclick) {
        this[onclick.fn_name](onclick.attr);
      }
    },

    refreshTable(data) {
      this.$emit("refresh-table", data);
    },

    openForm(data) {
      this.$emit("open-form", data);
    },

    getHandleActions(action, result = {}) {
      if (this.useBackendCrudActions && action === "crud") {
        return { crud: this.crud };
      }

      return this.getStoredActions(action, result);
    },

    getStoredActions(action, result = {}) {
      if (this.grid === "issue_center" || this.grid === "dynamic_issues") {
        // remade issues actions storing
        // set issues actions by issue_center, not by services)

        result = Object.keys(this.$store.state.grid[this.grid].actions)
          // removing current action
          .filter(key => key === action)
          // adding actions from store using "key" to result
          .reduce((r, key) => {
            r[key] = this.$store.state.grid[this.grid].actions[key];
            return r;
          }, {});

        if (result.handle) {
          // filtering handle from result, el.key should be included into available_transitions of this row
          result.handle = result.handle.filter(el => this.row.available_transitions.includes(el.key));
        }
      } else {
        result = Object.keys(this.currentGrid.actions)
          .filter(key => key === action)
          .reduce((r, key) => {
            r[key] = this.currentGrid.actions[key];
            return r;
          }, {});
      }
      return result;
    },
  },
};
</script>

<style lang="scss">
@import "../../../assets/styles/show/actions";
</style>
